import styled from 'styled-components'

export default styled.div`
  border-bottom: ${props => props.theme.border};
  width: 100%;
  margin: 20px 0;
`
